import { Injectable } from "@angular/core";
import { Logger } from "./logger";

/**
 * Factory for {@link Logger}.
 *
 * This factory can be injected by angular.
 *
 * @example
 * private logger: Logger;
 * constructor(
 *    loggerService: LoggerService
 *  ) {
 *    this.logger = loggerService.get("NewCirculationComponent");
 *    this.logger.info( "ctor called!");
 *  }
 *
 */
@Injectable({
  providedIn: "root"
})
export class LoggerService {
  public static get logDebug(): boolean {
    return Logger.logDebug;
  }

  public static set logDebug(value: boolean) {
    Logger.logDebug = value;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public static get(source: string | Function): Logger {
    if (typeof source === "string") {
      return new Logger(source);
    }

    //Maybe the function has a logger - else get a new
    const logger = (source as unknown as IHaveLogger).logger;
    if (logger !== null) {
      return logger;
    }
    return new Logger(source.prototype.name);
  }
}

interface IHaveLogger {
  logger: Logger;
}
